import {
	IconPersonChecked,
	IconPersons,
} from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from 'components/common/Menu';

const menuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'Accounts',
		link: '/montel-ppa/users',
		icon: <IconPersons />,
	},
	{
		type: 'Clickable',
		text: 'Subscriptions',
		link: '/montel-ppa/subscriptions',
		icon: <IconPersonChecked />,
	},
];

export default menuConfig;
